/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/right-panel/__generated__/rightPanelAsyncQuery.graphql.ts
 */

export const RIGHT_PANEL_ASYNC_QUERY_PERSISTED_ID = '1b285bd9c0f69f12205ff3d82a67734a98f412f776d2ff17f7329d17ee089ec0';
export const RIGHT_PANEL_ASYNC_QUERY_OPERATION_NAME = 'rightPanelAsyncQuery';
